import DetailViewContentElement from "../../../common/models/detailView/elements/detailViewContentElement";
import {FontSize} from "~/enums/fontSize";

export default class Heading extends DetailViewContentElement {
  font_size: number;
  constructor() {
    super();
    this.defineProperty("font_size", FontSize.Large)
  }
}